import { useCallback, useMemo } from 'react'
import { ApiCore } from '../services'
import { getGaClientId } from '@monorepo/service'

const TOP_DOMAIN =
  typeof window !== 'undefined' ? window.location.hostname.split('.').slice(-2).join('.') : ''

interface Props {
  balancerUrl?: string
  isBalancerInfoLoading?: boolean
  balancerInfo?: ApiCore.CDALandingsResponse | null
  geo?: string
}

export const useLogin = ({ balancerUrl, isBalancerInfoLoading, balancerInfo, geo }: Props) => {
  const origin = useMemo(() => {
    if (!balancerUrl && isBalancerInfoLoading) return
    return (
      balancerUrl ||
      `https://${balancerInfo?.landing_to_balancer?.[TOP_DOMAIN] || balancerInfo?.balancer}/`
    )
  }, [balancerUrl, isBalancerInfoLoading, balancerInfo])

  const redirectToLoginPage = useCallback(() => {
    if (!origin) return
    const currentParams = new URLSearchParams(window.location.search)

    currentParams.set('login', 'true')
    if (geo) currentParams.set('geo', geo)

    const gaClientId = getGaClientId()
    if (gaClientId) currentParams.set('_ga', gaClientId)

    window.location.href = `${origin}?${currentParams.toString()}`
  }, [geo, origin])

  return { origin, redirectToLoginPage }
}
